import script from "./order-detail.vue?vue&type=script&lang=tsx&setup=true"
export * from "./order-detail.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__